import './LoadingSpinner.scss'

interface LoadingSpinnerProps {
  size?: 80 | 40 | 20
  color?: 'light' | 'dark'
}

export function LoadingSpinner({
  size = 80,
  color = 'light',
}: LoadingSpinnerProps) {
  return (
    <div className={`loading-spinner ls-size-${size} ls-color-${color}`}></div>
  )
}
